<template>
  <div class="genres-page-container">
    <!-- 顶部导航/标签区域 -->
    <div class="genres-header">
      <div class="header-left">
        <span class="brand-icon"><i class="fas fa-film"></i></span>
        <span class="brand-text">CINEMAX</span>
      </div>
      <div class="header-right">
        <div class="search-box">
          <i class="fas fa-search"></i>
          <input type="text" placeholder="search video..." />
        </div>
        <div class="user-avatar">
          <i class="fas fa-user-circle"></i>
        </div>
      </div>
    </div>

    <!-- 分类标签 -->
    <div class="tags-bar">
      <div class="tags-scroll">
        <span class="tag-item" :class="{ active: tag_id === 0 }" @click="onTags(0)"> All Plots </span>
        <span class="tag-item" :class="{ active: tag_id === item.id }" v-for="item in videoTags" :key="item.id" @click="onTags(item.id)">
          {{ item.name }}
        </span>
      </div>
      <div class="tags-actions">
        <i class="iconfont icon-zuojiantou"></i>
      </div>
    </div>

    <!-- 视频列表 -->
    <div class="video-grid">
      <div class="video-card" v-for="item in videoList" :key="item.code || item.id" @click="onPlay(item.code)">
        <!-- 封面图 - 220x290 比例 -->
        <div class="card-cover">
          <img :src="item.img" :alt="item.title" loading="lazy" />
          <div class="cover-overlay">
            <span class="play-icon-btn"><i class="fas fa-play-circle"></i></span>
          </div>
          <div class="cover-badge" v-if="item.badge">{{ item.badge }}</div>
        </div>

        <!-- 内容信息 -->
        <div class="card-body">
          <h3 class="card-title">{{ item.title }}</h3>
          <p class="card-desc">{{ item.content || item.desc }}</p>
          <div class="card-meta">
            <span class="meta-item"> <i class="fas fa-heart"></i> {{ formatNumber(item.collect || item.likes || 0) }} </span>
            <span class="meta-item"> <i class="fas fa-eye"></i> {{ formatNumber(item.views || item.watch || 0) }} </span>
            <span class="meta-item" v-if="item.year"> <i class="far fa-calendar-alt"></i> {{ item.year }} </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div class="empty-state" v-if="videoList.length === 0 && !loading">
      <i class="fas fa-inbox"></i>
      <p>{{ $t('emptyData') }}</p>
    </div>

    <!-- 分页组件 -->
    <div class="pagination-wrapper">
      <div class="pagination-inner">
        <!-- <button class="page-btn prev" :disabled="page <= 1" @click="onPage(page - 1)">
          <i class="iconfont icon-zuojiantou"></i>
        </button> -->

        <template v-for="(p, idx) in pages.pages" :key="idx">
          <span class="page-ellipsis" v-if="idx === 0 && pages.showStartEllipsis">…</span>
          <button class="page-btn num" :class="{ active: p === page }" @click="onPage(p)">
            {{ p }}
          </button>
          <span class="page-ellipsis" v-if="idx === pages.pages.length - 1 && pages.showEndEllipsis">…</span>
        </template>

        <!-- <button class="page-btn next" :disabled="page >= pages.total" @click="onPage(page + 1)">
          <i class="iconfont icon-youjiantou"></i>
        </button> -->
      </div>
      <div class="page-info">{{ page }} / {{ pages.total || 1 }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenresVue',
  props: {
    cateId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      videoTags: [],
      tag_id: 0,
      videoList: [],
      page: 1,
      size: 30,
      total: 0,
      loading: false
    }
  },
  computed: {
    pages() {
      const total = Math.ceil(this.total / this.size) || 1
      const current = this.page
      const only = 5

      let pages = []
      let showStartEllipsis = false
      let showEndEllipsis = false

      if (total <= only) {
        for (let i = 1; i <= total; i++) {
          pages.push(i)
        }
      } else {
        if (current <= 3) {
          for (let i = 1; i <= only; i++) {
            pages.push(i)
          }
          showEndEllipsis = true
        } else if (current >= total - 2) {
          for (let i = total - only + 1; i <= total; i++) {
            pages.push(i)
          }
          showStartEllipsis = true
        } else {
          for (let i = current - 2; i <= current + 2; i++) {
            pages.push(i)
          }
          showStartEllipsis = true
          showEndEllipsis = true
        }
      }

      return {
        pages,
        showStartEllipsis,
        showEndEllipsis,
        total
      }
    }
  },
  created() {
    this.$nextTick(function () {
      this.getVideoPageList()
      this.getVideoTagsList()
    })
  },
  methods: {
    getVideoTagsList() {
      this.$api.video
        .getVideoTagsList({
          cate_id: this.cateId
        })
        .then((res) => {
          this.videoTags = res.data
        })
    },
    onTags(id) {
      this.tag_id = id
      this.page = 1
      this.getVideoPageList()
    },

    getVideoPageList() {
      this.loading = true
      let hide = this.$message?.loading?.({ content: 'Loading...', key: 'msg' }) || (() => {})
      this.$api.video
        .getVideoPageList({
          cate_id: this.cateId,
          page: this.page,
          size: this.size,
          tag_id: this.tag_id
        })
        .then((res) => {
          if (hide && typeof hide === 'function') hide()
          this.videoList = res.data.data
          this.page = res.data.current
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          if (hide && typeof hide === 'function') hide()
          this.videoList = []
          this.total = 0
          this.loading = false
        })
    },

    onPlay(code) {
      if (!code) return
      this.$router.push({ name: 'video', query: { code: code } })
    },

    onPage(page) {
      if (page < 1 || page > this.pages.total) return
      this.page = page
      this.getVideoPageList()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    formatNumber(num) {
      if (!num) return '0'
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + 'w'
      } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'k'
      }
      return num.toString()
    }
  }
}
</script>

<style scoped>
/* ===== 暗色主题样式 ===== */
.genres-page-container {
  width: 1440px;
  margin: 0 auto;
  padding: 20px 24px 40px;
  background-color: #0b0d0f;
  color: #e8edf2;
  min-height: 100vh;
}

/* ----- 顶部导航 ----- */
.genres-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0 20px;
  border-bottom: 1px solid #1e2329;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-icon {
  font-size: 28px;
  color: #e50914;
}

.brand-text {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #e50914, #b20710);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-box {
  display: flex;
  align-items: center;
  background: #181e24;
  border-radius: 24px;
  padding: 6px 16px;
  border: 1px solid #2a3138;
  transition: border-color 0.3s;
}

.search-box:focus-within {
  border-color: #e50914;
}

.search-box i {
  color: #8a949f;
  font-size: 14px;
  margin-right: 8px;
}

.search-box input {
  background: transparent;
  border: none;
  outline: none;
  color: #e8edf2;
  font-size: 14px;
  padding: 6px 0;
  width: 140px;
}

.search-box input::placeholder {
  color: #5e6a76;
}

.user-avatar {
  font-size: 32px;
  color: #8a949f;
  cursor: pointer;
  transition: color 0.3s;
}

.user-avatar:hover {
  color: #e8edf2;
}

/* ----- 标签栏 ----- */
.tags-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 12px;
  flex-wrap: wrap;
}

.tags-scroll {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  overflow-x: auto;
  padding-bottom: 4px;
  flex: 1;
}

.tag-item {
  padding: 6px 18px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  background: #181e24;
  color: #8a949f;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
  border: 1px solid transparent;
  user-select: none;
}

.tag-item:hover {
  background: #232b33;
  color: #e8edf2;
}

.tag-item.active {
  background: #e50914;
  color: #fff;
  border-color: #e50914;
  box-shadow: 0 0 20px rgba(229, 9, 20, 0.3);
}

.tags-actions {
  color: #8a949f;
  font-size: 18px;
  padding: 6px 12px;
  border-radius: 20px;
  background: #181e24;
  cursor: pointer;
  transition: 0.3s;
}

.tags-actions:hover {
  color: #e8edf2;
  background: #232b33;
}

/* ============================================================
   核心修改：封面图 220x290 比例
   ============================================================ */

/* ----- 视频网格：一行4个，固定宽度适配220x290 ----- */
.video-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;
  margin-bottom: 40px;
  justify-content: center;
}

.video-card {
  width: 220px;
  background: #13191f;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #1e2329;
}

.video-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
  border-color: #2a3138;
}

/* ===== 封面：固定 220x290 ===== */
.card-cover {
  position: relative;
  width: 220px;
  height: 290px;
  background: #0f1419;
  overflow: hidden;
  flex-shrink: 0;
}

.card-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
  display: block;
}

.video-card:hover .card-cover img {
  transform: scale(1.05);
}

.cover-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.video-card:hover .cover-overlay {
  opacity: 1;
}

.play-icon-btn {
  font-size: 52px;
  color: #fff;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.8);
  transition: transform 0.3s ease;
}

.video-card:hover .play-icon-btn {
  transform: scale(1.1);
}

.cover-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(229, 9, 20, 0.85);
  backdrop-filter: blur(4px);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* ===== 卡片内容 ===== */
.card-body {
  padding: 12px 14px 14px;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #f0f4f8;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-desc {
  font-size: 12px;
  color: #8a949f;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 34px;
  margin-bottom: 8px;
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: #6a7a8a;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.meta-item i {
  font-size: 12px;
  color: #5e6a76;
}

/* ----- 空状态 ----- */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #5e6a76;
}

.empty-state i {
  font-size: 56px;
  margin-bottom: 16px;
  opacity: 0.4;
}

.empty-state p {
  font-size: 18px;
}

/* ----- 分页 ----- */
.pagination-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding-top: 16px;
  border-top: 1px solid #1e2329;
}

.pagination-inner {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}

.page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0 10px;
  border-radius: 10px;
  border: none;
  background: #181e24;
  color: #a0abb8;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  border: 1px solid transparent;
}

.page-btn:hover:not(:disabled) {
  background: #232b33;
  color: #e8edf2;
  border-color: #2a3138;
}

.page-btn.active {
  background: #e50914;
  color: #fff;
  border-color: #e50914;
  box-shadow: 0 0 20px rgba(229, 9, 20, 0.25);
}

.page-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.page-btn.prev,
.page-btn.next {
  background: #13191f;
  font-size: 16px;
}

.page-ellipsis {
  color: #5e6a76;
  padding: 0 4px;
  font-size: 14px;
}

.page-info {
  font-size: 13px;
  color: #5e6a76;
}

/* ===== 响应式 ===== */

/* 平板：一行3个 */
@media (max-width: 1024px) {
  .video-grid {
    grid-template-columns: repeat(3, 220px);
    gap: 20px;
  }
}

/* 手机：一行2个 */
@media (max-width: 768px) {
  .genres-page-container {
    padding: 12px 12px 30px;
  }

  .genres-header {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .header-right {
    justify-content: space-between;
  }

  .search-box input {
    width: 100px;
  }

  .video-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    justify-items: center;
  }

  .video-card {
    width: 100%;
    max-width: 220px;
  }

  .card-cover {
    width: 100%;
    height: auto;
    aspect-ratio: 220 / 290;
  }

  .tag-item {
    font-size: 12px;
    padding: 4px 14px;
  }

  .page-btn {
    min-width: 34px;
    height: 34px;
    font-size: 13px;
  }
}

/* 小手机：一行1个 */
@media (max-width: 480px) {
  .video-grid {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .video-card {
    max-width: 100%;
  }

  .card-cover {
    aspect-ratio: 220 / 290;
  }

  .card-body {
    padding: 10px 10px 12px;
  }

  .card-title {
    font-size: 13px;
  }

  .card-desc {
    font-size: 11px;
    -webkit-line-clamp: 1;
    min-height: 18px;
  }

  .card-meta {
    font-size: 11px;
    gap: 8px;
  }

  .cover-badge {
    font-size: 9px;
    padding: 2px 10px;
    top: 8px;
    left: 8px;
  }
}
</style>
